import React, { useState, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';

export const DisplayUtil = ({ mobileView, tabletView, desktopView }) => {
  const [isClient, setIsClient] = useState(false);
  const isDesktop = useMediaQuery({ minWidth: 1024 });
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1023 });
  const isMobile = useMediaQuery({ maxWidth: 767 });

  useEffect(() => setIsClient(true), []);

  // During SSR and initial client render, return mobileView as default
  if (!isClient) {
    return mobileView;
  }

  // After hydration, use media queries
  if (isDesktop) {
    return desktopView;
  }
  if (isTablet) {
    return tabletView;
  }
  if (isMobile) {
    return mobileView;
  }

  // Default fallback
  return mobileView;
};
